import React, { useEffect, useContext, useState, useCallback } from "react";
import { Typography, Backdrop, CircularProgress, Box } from "@mui/material";
import { ContainerPaper, ProgramTabs } from "../../components/";
import styles from "./styles.module.scss";
import { AuthenticatedContext, ModuleContext } from "../../App";
import { useLazyQuery } from "@apollo/client";
import { GET_DASHBOARD } from "../../graphql/queries";

const PlacementCards = () => {
  const { exitSitting } = useContext(ModuleContext);
  const [programData, setProgramData] = useState([]);
  const [placementCards, setPlacementCards] = useState({
    placements: [],
    programs: [],
  });

  const { loading, setLoading, setPlacementsDone, userRole, userToken, user, getRole } =
    useContext(AuthenticatedContext);

  const [getDashboard] = useLazyQuery(GET_DASHBOARD, {
    onCompleted: (dashboardItems) => {
      if (userRole === "Student") {
        try {
          if (dashboardItems.getDashboard?.placements) {
            setPlacementCards(dashboardItems.getDashboard);
            setPlacementsDone(false);
            setLoading(false);
          }
        } catch (error) {
          console.error("Error processing dashboard data:", error);
          setLoading(false);
        }
      }
    },
    onError: (error) => {
      console.log(`getDashboard Error ${error}`);
      setLoading(false);
    },
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (
      placementCards?.placements?.length > 0 &&
      placementCards?.programs?.length > 0
    ) {
      const newProgramData = placementCards.programs.map((program) => {
        let programCards = placementCards.placements.filter((c) =>
          c.Programs?.find((p) => p?.Program?.id === program?.id)
        );

        if (program?.hasDiagnostic && !programCards.find((c) => c.diagnostic)) {
          programCards.push({
            id: program.id,
            name: `${program.name} Diagnostic Test`,
            Sittings: program.DiagnosticSittings,
            diagnostic: true,
            languageId: placementCards.placements[0].languageId,
          });
        }
        return {
          programName: program.name,
          programCards: [...programCards],
        };
      });
      setProgramData(newProgramData);
    }
  }, [placementCards]);

  const callDashboard = useCallback(() => {
    if (userToken && user && userRole) {
      getDashboard({
        variables: {
          user_id: JSON.parse(user)?.student_id,
          role: userRole,
        },
      });
    }
  }, [userToken, user, userRole, getDashboard]);

  useEffect(() => {
    if (userRole) {
      setLoading(true);
      callDashboard();
    } else {
      getRole();
    }
    
  }, [userRole]);

  const handleExitSitting = useCallback(() => {
    exitSitting();
  }, []);

  useEffect(() => {
    handleExitSitting();
  }, [handleExitSitting]);

  return (
    <ContainerPaper>
      {loading && (
        <Backdrop sx={{ zIndex: 10000 }} open={loading}>
          <CircularProgress />
        </Backdrop>
      )}
      {placementCards.placements?.length === 0 ? null : (
        <>
          <Box>
            <Typography
              color="primary"
              gutterBottom
              variant="h3"
              sx={{ mt: 0, mb: 0 }}
              className={styles.title}
            >
              Start Your Problem Solving Assessment Here
            </Typography>
          </Box>

          <ProgramTabs programData={programData} />
        </>
      )}
    </ContainerPaper>
  );
};

export default React.memo(PlacementCards);
